import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import { translateFr as tfr } from "@/i18n";
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUSES = [
  "Repéré",
  "Contacté",
  "En discussion",
  "Mandat signé",
  "Placé",
];

export const STATUS_DOT = {
  "Repéré": "dot-repere",
  "Contacté": "dot-contacte",
  "En discussion": "dot-discussion",
  "Mandat signé": "dot-mandat",
  "Placé": "dot-place",
};

export const STATUS_BADGE = {
  "Repéré": "bg-muted text-muted-foreground border-border",
  "Contacté": "bg-info/10 text-info border-info/30",
  "En discussion": "bg-warning/10 text-warning border-warning/30",
  "Mandat signé": "bg-success/10 text-success border-success/30",
  "Placé": "bg-success/15 text-success border-success/40",
};

export const STATUS_HEX = {
  "Repéré": "#8B5CF6",
  "Contacté": "#3B82F6",
  "En discussion": "#F59E0B",
  "Mandat signé": "#22C55E",
  "Placé": "#10B981",
};

export function relativeFr(iso) {
  const en = (() => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } })();
  if (!iso) return en ? "Never" : "Jamais";
  const d = new Date(iso);
  const diff = Math.max(0, Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24)));
  if (diff < 1) return en ? "Today" : "Aujourd'hui";
  if (diff === 1) return en ? "Yesterday" : "Hier";
  if (diff < 30) return en ? `${diff}d ago` : `il y a ${diff}j`;
  const m = Math.floor(diff / 30);
  if (m === 1) return en ? "1 month ago" : "il y a 1 mois";
  return en ? `${m} months ago` : `il y a ${m} mois`;
}

export function heatScore(player) {
  // Heat for active discussions: HOT (recent contact, advanced status) / WARM / COLD
  if (!player) return { level: "cold", label: "Inactif", className: "text-muted-foreground bg-muted/40 border-border" };
  const last = player.last_interaction_at ? new Date(player.last_interaction_at) : null;
  const days = last ? Math.floor((Date.now() - last.getTime()) / (1000 * 60 * 60 * 24)) : 999;
  const advanced = ["En discussion", "Mandat signé"].includes(player.status);
  if (advanced && days <= 7) {
    return { level: "hot", label: "Urgent", className: "text-danger bg-danger/10 border-danger/30" };
  }
  if (days <= 14) {
    return { level: "warm", label: tfr("À suivre"), className: "text-warning bg-warning/10 border-warning/30" };
  }
  return { level: "cold", label: "Inactif", className: "text-muted-foreground bg-muted/40 border-border" };
}

export function dateLocale() {
  try { return localStorage.getItem("athlynx_lang") === "en" ? "en-GB" : "fr-FR"; } catch { return "fr-FR"; }
}

export function formatDate(iso) {
  if (!iso) return "";
  const en = (() => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } })();
  const d = new Date(iso);
  return d.toLocaleDateString(en ? "en-GB" : "fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatTime(iso) {
  if (!iso) return "";
  const en = (() => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } })();
  const d = new Date(iso);
  return d.toLocaleTimeString(en ? "en-GB" : "fr-FR", { hour: "2-digit", minute: "2-digit" });
}

export const initialsOf = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";

export const LOGOS = {
  white:
    "https://customer-assets.emergentagent.com/job_858cc7a7-7cc8-44d9-aa44-6d9b1be3719b/artifacts/bj5l40yn_logoAthlynkwhite.svg",
  black:
    "https://customer-assets.emergentagent.com/job_858cc7a7-7cc8-44d9-aa44-6d9b1be3719b/artifacts/7xdz38zf_logoAthlynkblack.svg",
};
